// You can write your custom Javascript here
window.addEventListener('load', function () { 
  setTimeout(function(){      
    if(document.querySelector('.collection-buttons--wrapper-NEW') !== null) {       
      new Swiper('.collection-buttons--wrapper-NEW', { slidesPerView: 'auto', spaceBetween: 0, resitance: false });    }
  }, 4000);      
}, false); 